import { HistoryTerm } from '@empathy/search-types';
import { HistoryState } from '../../../models';
import { HISTORY_MUTATIONS_KEYS } from '../history.const';
import { HistoryMutation } from '../history.interfaces';

export class SetQueryHistoryMutation implements HistoryMutation {
  mutations = {
    [HISTORY_MUTATIONS_KEYS.setQueryHistory]: (localState: HistoryState, history: HistoryTerm[]) => {
      localState.queryHistory = history;
    }
  };
}
